import { FC, ReactNode, useEffect } from "react";
import * as S from "./styles";
import { SVG } from "../SVG";
import { faClose } from "@fortawesome/pro-light-svg-icons";
import { Portal } from "~/helpers/portal";
import { useUserPilotSearchParams } from "~/hooks/useUserPilotSearchParams";
import { useMediaQuery } from "~/hooks/useMediaQuery";

export interface IModalProps {
  isShowing: boolean;
  hide?: () => void;
  children: ReactNode;
  padding?: string;
  minWidth?: string | number;
  maxWidth?: string | number;
  hideCloseButton?: boolean;
  maxHeight?: string;
  fixedElement?: ReactNode;
  id?: string;
  width?: number | string;
  /** When false, overlay clicks do not dismiss (no hide / Userpilot URL update). Default true. */
  closeOnBackdropClick?: boolean;
  scrollable?: "auto" | "hidden";
}

const Modal: FC<IModalProps> = ({
  isShowing,
  hide,
  children,
  padding,
  minWidth,
  maxHeight,
  hideCloseButton,
  fixedElement,
  id,
  maxWidth,
  width,
  closeOnBackdropClick = true,
  scrollable = "auto",
}) => {
  const handleSearchParamUpdate = useUserPilotSearchParams(id, isShowing);
  const isAboveTablet = useMediaQuery("tablet");

  const handleHide = () => {
    if (id) handleSearchParamUpdate(false, id);
    if (hide) {
      hide();
    }
  };

  if (!isShowing) return null;

  return (
    <Portal>
      <S.ModalWrapper
        className="modal-wrapper"
        onClick={closeOnBackdropClick ? handleHide : undefined}>
        <S.ModalContent
          className="modal-content"
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          minWidth={minWidth ? minWidth : "fit-content"}
          width={width ? width : "auto"}
          onClick={(e) => e.stopPropagation()}
          scrollable={scrollable}>
          {hide && !hideCloseButton ? (
            <S.CloseContainer className="close-button" onClick={handleHide}>
              <SVG icon={faClose} size="xl" />
            </S.CloseContainer>
          ) : null}
          <S.ModalScrollWrapper padding={padding}>
            {children}
          </S.ModalScrollWrapper>
        </S.ModalContent>
      </S.ModalWrapper>

      {fixedElement ? <S.FixedElement>{fixedElement}</S.FixedElement> : null}
    </Portal>
  );
};

export default Modal;
